<script setup>
import { useCmsContentStore } from '@/stores'
import CmsText from '@/@core/components/CmsText.vue'

const props = defineProps({
  highlightTestimonial: {
    type: String,
  },
  hideTestimonial: {
    type: String,
  }
})

const cmsStore = useCmsContentStore()

// Default testimonials — used as fallback if CMS block not yet loaded
const defaultTestimonials = [
  {
    text: "RM is awesome - everyone on my team across the country is a member & loves it. We use for business dinners & personally. Makes it easy for my wife & I to get last minute date nights at our favorite places & she says so fun!",
    name: "Justin Ishbia",
    company: "Managing Partner, Shore Capital Partners",
    company2: "Alternate Governor, Phoenix Suns & Phoenix Mercury"
  },
  {
    text: "RM is the best reservation app! My go-to for securing reservations at top restaurants worldwide – gets me better access than my Black cards/services. My high-profile friends, including prominent athletes & team owners, enjoy it too.",
    name: "Les Coney",
    company: "Partner, Mesirow",
    company2: "Investor/Owner, RPM Restaurants (LEYE) & Sunda",
    company3: "Co-Owner, Chicago Sky"
  },
  {
    text: "RM is one of the best employee benefits we've provided.  Having restaurateurs friends & investing in restaurants, I already enjoyed great access - now with RM, my team does, too.  I also don't have to text my friends anymore!",
    name: "Tony Davis",
    company: "Managing Partner & Co-Founder, Linden Capital Partners"
  },
  {
    text: "Getting reservations is so much better via RM! Otherwise impossible at the restaurants you want to go to unless you know someone & always awkward to ask favors.",
    name: "Sonia Veluchamy",
    company: "CEO, Celegence"
  },
  {
    text: "My wife & I love RM. It's a lifesaver! We get all our reservations on it with access to the best restaurants on short notice.",
    name: "Harit Talwar",
    company: "Board Member of Mastercard & Chairman of Better"
  },
  {
    text: "I am a huge fan of RM!  Long overdue for the restaurant space & membership pays for itself with just 1 reservation. I use it for all of my client meals & enjoy it for date nights too.",
    name: "Galen Mason",
    company: "Partner & Co-Chair, Venture Best"
  }
]

// Use CMS block if loaded, otherwise fall back to hardcoded defaults
const cmsTestimonials = cmsStore.useBlock('home.testimonials')

const testimonials = computed(() => {
  return (Array.isArray(cmsTestimonials.value) && cmsTestimonials.value.length > 0)
    ? cmsTestimonials.value
    : defaultTestimonials
})

// if props.highlightedTestimonial we bring it to the top
const orderedTestimonials = computed(() => {
  let items = [...testimonials.value]
  let prependTestimonials = []
  let highlightedTestimonial = null
  if(props.highlightTestimonial){
    highlightedTestimonial = items.find( testimonial => testimonial.name == props.highlightTestimonial )
  }
  if(highlightedTestimonial){
    prependTestimonials.push(highlightedTestimonial)
  }

  //remove any testimonials that match hideTestimonial
  if(props.hideTestimonial){
    items = items.filter( testimonial => testimonial.name != props.hideTestimonial )
  }

  return prependTestimonials.concat(items.filter( testimonial => testimonial.name != props.highlightTestimonial ))
})
</script>

<template>
  <section class="pb-16">
    <div class="content-wrapper">
      <CmsText
        k="home.testimonials.title"
        tag="h2"
        class="section-subtitle text-center"
      />
      <div class="testimonials-holder">
        <div class="testimonials-wrapper">
          <div
            v-for="(testimonal, index) in orderedTestimonials"
            :key="index"
          >
            <div class="testimonial">
              <p class="testimonial-text">
                {{ testimonal.text }}
              </p>
              <span class="testimonial-name">{{ testimonal.name }}</span>
              <span class="testimonial-company">{{ testimonal.company }}</span>
              <span
                v-if="testimonal.company2"
                class="testimonial-company"
              >{{ testimonal.company2 }}</span>
              <span
                v-if="testimonal.company3"
                class="testimonial-company"
              >{{ testimonal.company3 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


